import { Contact } from "@/services/backend/contacts/contact/contact";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { Skeleton } from "@/shared/components/ui/skeleton";

export function ContactInfoCard({ contact }: { contact: Contact }) {
  return (
    <Card className="shadow-none">
      <CardHeader>
        <CardTitle>{contact.name}</CardTitle>
        <CardDescription>{contact.function}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">Telefon</div>
          <div>{contact.phone}</div>
        </div>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">Mobil</div>
          <div>{contact.mobilephone}</div>
        </div>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">E-Mail</div>
          <div>{contact.email}</div>
        </div>
      </CardContent>
    </Card>
  );
}

export function ContactInfoCardSkeleton() {
  return (
    <Card className="shadow-none">
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-6 w-48" />
        </CardTitle>
        <Skeleton className="h-4 w-32" />
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">Telefon</div>
          <Skeleton className="h-4 w-32" />
        </div>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">Mobil</div>
          <Skeleton className="h-4 w-32" />
        </div>
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">E-Mail</div>
          <Skeleton className="h-4 w-32" />
        </div>
      </CardContent>
    </Card>
  );
}
